import React, { Component } from 'react';
import uuid from 'uuid';


class SizeSelector extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.handleSizeChange = this.handleSizeChange.bind(this);
  }

  handleSizeChange(event) {
    const { componentToSize } = this.props;
    componentToSize.setState({ size: event.target.value });
  }

  render () {
    return (
      <div>
        <p>Change Size:</p>
        <select className="push-half--bottom" id={uuid()} onChange={this.handleSizeChange} style={{ 'maxWidth': '160px', 'display': 'inline' }}>
          <option value="medium" selected>Default(Medium)</option>
          <option value="x-small">x-small</option>
          <option value="small">small</option>
          <option value="large">large</option>
        </select>
      </div>
    );
  }
}

export default SizeSelector;



// WEBPACK FOOTER //
// ./styleguide/components/sizeSelector.js